  // state
  const state = () => ({
    orderDataList: [],
    isOrderLoading: false,
    isModalConvertOrder: false,
    isModalOrderConfirm: false,
    isModalSendOrderErp: false,
    isModalSendOrderCrm: false,
    showModalAfterAction: false,
    showModalAfterChat: false,
    orderId:'',
    dataIncomming:{},
    dataUpdated:{}
  });
  
  // getters
  const getters = {};
  
  // actions
  const actions = {
    setInProgressOrder({ commit }, payload) {
      commit('setInProgressOrder', payload);
    },
    orderDataList({ commit }, data) {
      commit('setOrderDataList', data);
    },
    isModalConvertOrder({ commit }, payload) {
      commit('setModalConvertOrder', payload);
    },
    isModalOrderConfirm({ commit }, payload) {
      commit('setModalOrderConfirm', payload);
    },
    isModalSendOrderErp({ commit }, payload) {
      commit('setModalSendOrderErp', payload);
    },
    isModalSendOrderCrm({ commit }, payload) {
      commit('setModalSendOrderCrm', payload);
    },
    showModalAfterAction({ commit }, fields) {
      commit('showModalAfterAction', fields);
    },
    showModalAfterChat({ commit }, fields) {
      commit('showModalAfterChat', fields);
    },
    orderId({ commit }, fields) {
      commit('orderId', fields);
    },
    dataIncomming({ commit }, fields) {
      commit('dataIncomming', fields);
    },
    dataUpdated({ commit }, fields) {
      commit('dataUpdated', fields);
    },
  };
  
  // mutations
  const mutations = {

    setInProgressOrder(state, payload) {
      state.orderDataList['data'] = state.orderDataList['data'].map(function(orderlist){

        if(payload.orderIds.includes(orderlist.id)){
          orderlist = {...orderlist, loading: true};
          return {...orderlist, loading: payload.status};
        }

        return orderlist;
      });

      state.isOrderLoading = !state.isOrderLoading;
    },
    setOrderDataList(state, data) {
      state.orderDataList = data;
    },
    setModalConvertOrder(state, payload) {
      state.isModalConvertOrder = payload;
    },
    setModalOrderConfirm(state, payload) {
      state.isModalOrderConfirm = payload;
    },
    setModalSendOrderErp(state, payload) {
      state.isModalSendOrderErp = payload;
    },
    setModalSendOrderCrm(state, payload) {
      state.isModalSendOrderCrm = payload;
    },
    showModalAfterAction(state, data) {
      state.showModalAfterAction = data;
    },
    showModalAfterChat(state, data) {
      state.showModalAfterChat = data;
    },
    orderId(state, data) {
      state.orderId = data;
    },
    dataIncomming(state, data) {
      state.dataIncomming = data;
    },
    dataUpdated(state, data) {
      state.dataUpdated = data;
    },
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };


// WEBPACK FOOTER //
// ./src/store/modules/order.js